import { Component, OnChanges, Input, ViewChild } from '@angular/core';

import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { DailyProdHighlights,DPHDayToken } from '../../shared/misc-classes';
@Component({
  selector: 'app-daily-prod',
  templateUrl: './daily-prod.component.html',
  styleUrls: ['./daily-prod.component.css']
})
export class DailyProdComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() dProdHighObj:DailyProdHighlights;
  dDPHDayTokenObj:DPHDayToken;  

  constructor(public _dataService: DataService) { }

  ngOnChanges() {
    this.loadDateData();
  }
  loadDateData():void{
    if(this.dDPHDayTokenObj){
      let _tmpDPHDayToken:DPHDayToken = this.dProdHighObj.getDateToken(this.currMonthDtObj);
        if(_tmpDPHDayToken == null){
          this.dProdHighObj.addDateToken(this.currMonthDtObj);  
          _tmpDPHDayToken = this.dProdHighObj.getDateToken(this.currMonthDtObj);
        }
        this.dDPHDayTokenObj = _tmpDPHDayToken;
    }
    else{
      this.dDPHDayTokenObj = new DPHDayToken(this.currMonthDtObj,[])
    }
    
  }

  formatDate(_date: Date): string {
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }

  getProductName(_prodId: string): string {
    if (_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getCustomerName(_custId: string): string {
    if (_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
}
